import Vue from 'vue'

// Qonversion Web SDK pour tracking analytics
class QonversionSDK {
  constructor() {
    this.apiKey = import.meta.env.VITE_QONVERSION_API_KEY || ''
    this.userId = null
    this.isInitialized = false
    this.events = []
  }

  // Initialiser Qonversion
  async init(userId) {
    try {
      this.userId = userId
      this.isInitialized = true
      console.log('[Qonversion] Initialized for user:', userId)
      
      // Identifier l'utilisateur
      this.identify(userId)
      
      // Envoyer les événements en attente
      this.flushEvents()
    } catch (err) {
      console.error('[Qonversion] Initialization error:', err)
    }
  }

  // Identifier un utilisateur
  identify(userId, properties = {}) {
    if (!this.apiKey) return
    
    const data = {
      userId,
      timestamp: Date.now(),
      properties: {
        platform: 'web',
        ...properties
      }
    }
    
    console.log('[Qonversion] User identified:', data)
    this.sendEvent('identify', data)
  }

  // Tracker un événement de conversion
  trackConversion(source, amount, currency = 'EUR') {
    const event = {
      type: 'conversion',
      userId: this.userId,
      source,
      amount,
      currency,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] Conversion tracked:', event)
    this.sendEvent('conversion', event)
    
    // Aussi envoyer à Google Analytics
    if (window.gtag) {
      window.gtag('event', 'purchase', {
        value: amount,
        currency: currency,
        transaction_id: `${this.userId}_${Date.now()}`
      })
    }
  }

  // Tracker une tentative de feature locked
  trackFeatureAttempt(featureName, userRole) {
    const event = {
      type: 'feature_attempt',
      userId: this.userId,
      feature: featureName,
      userRole,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] Feature attempt tracked:', event)
    this.sendEvent('feature_attempt', event)
  }

  // Tracker l'affichage d'un trigger
  trackTriggerShown(triggerType, triggerContext) {
    const event = {
      type: 'trigger_shown',
      userId: this.userId,
      triggerType,
      triggerContext,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] Trigger shown:', event)
    this.sendEvent('trigger_shown', event)
    
    // Google Analytics
    if (window.gtag) {
      window.gtag('event', 'trigger_shown', {
        trigger_type: triggerType,
        trigger_context: triggerContext
      })
    }
  }

  // Tracker une interaction avec un CTA
  trackCTAClick(ctaType, ctaContext, ctaWording) {
    const event = {
      type: 'cta_click',
      userId: this.userId,
      ctaType,
      ctaContext,
      ctaWording,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] CTA clicked:', event)
    this.sendEvent('cta_click', event)
    
    // Google Analytics
    if (window.gtag) {
      window.gtag('event', 'cta_click', {
        cta_type: ctaType,
        cta_context: ctaContext
      })
    }
  }

  // Tracker l'usage (limites)
  trackUsage(usageType, current, limit) {
    const event = {
      type: 'usage_tracked',
      userId: this.userId,
      usageType,
      current,
      limit,
      percentage: limit ? (current / limit) * 100 : 0,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] Usage tracked:', event)
    this.sendEvent('usage', event)
  }

  // Tracker un blocage (limite atteinte)
  trackLimitReached(limitType, value) {
    const event = {
      type: 'limit_reached',
      userId: this.userId,
      limitType,
      value,
      timestamp: Date.now()
    }
    
    console.log('[Qonversion] Limit reached:', event)
    this.sendEvent('limit_reached', event)
    
    // Google Analytics
    if (window.gtag) {
      window.gtag('event', 'limit_reached', {
        limit_type: limitType,
        value: value
      })
    }
  }

  // Envoyer un événement
  sendEvent(eventType, data) {
    if (!this.isInitialized) {
      this.events.push({ eventType, data })
      return
    }

    // Envoyer à votre backend pour agrégation
    const apiUrl = import.meta.env.VITE_APP_API_URI
    if (apiUrl) {
      fetch(`${apiUrl}/api/analytics/track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event: eventType,
          data,
          timestamp: Date.now()
        })
      }).catch(err => {
        console.error('[Qonversion] Error sending event:', err)
      })
    }
  }

  // Envoyer les événements en attente
  flushEvents() {
    if (this.events.length === 0) return
    
    console.log('[Qonversion] Flushing', this.events.length, 'pending events')
    this.events.forEach(({ eventType, data }) => {
      this.sendEvent(eventType, data)
    })
    this.events = []
  }

  // Obtenir les propriétés de l'utilisateur
  getUserProperties() {
    return {
      userId: this.userId,
      timestamp: Date.now()
    }
  }
}

// Instance singleton
const qonversion = new QonversionSDK()

// Plugin Vue
const QonversionPlugin = {
  install(Vue) {
    Vue.prototype.$qonversion = qonversion
  }
}

export default QonversionPlugin
export { qonversion }

